<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'TableFilterRadioGroup',
  computed: {
    ...mapState({
      radio: state => state.supplierPayments.filter.data.selectedTableType,
      filterLoading: state => state.supplierPayments.filter.data.loading,
      filterError: state => state.supplierPayments.filter.data.error,
      loading: state => state.supplierPayments.tableData.loading,
    }),
    disabled() {
      return this.filterLoading || this.filterError || this.loading;
    },
  },
  methods: {
    ...mapActions({
      updateFilterActiveTable: 'supplierPayments/updateFilterActiveTable',
    }),
  },
};
</script>

<template>
  <v-content class="ma-0 pa-0">
    <h2 class="text-xs-center">{{ $t('payments.filters.table') }}</h2>
    <v-divider class="table-filter-radio-group__divider"/>
    <v-container grid-list-md>
      <v-radio-group
        @change="updateFilterActiveTable"
        :value="radio"
        class="ma-0 pa-0 justify-center"
      >
        <v-radio
          :label="$t('supplierPayments.lists.titles.paid')"
          :value="1"
          class="pb-3"
          :disabled="disabled"
        />
        <v-radio
          :label="$t('supplierPayments.lists.titles.due')"
          :value="2"
          class="pb-3"
          :disabled="disabled"
        />
        <v-radio
          :label="$t('supplierPayments.lists.titles.payments')"
          :value="3"
          class="pb-3"
          :disabled="disabled"
        />
      </v-radio-group>
    </v-container>
  </v-content>
</template>

<style lang="scss">
  .table-filter-radio-group {
    &__divider {
      margin-left: 30%;
      margin-right: 30%;
      margin-bottom: 15px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/payments/supplier-payments/SupplierPaymentsTableFilterRadioGroup.vue